import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const TimesheetModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 4C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H11.5278C10.5777 18.9385 10 17.5367 10 16C10 12.6863 12.6863 10 16 10C17.5367 10 18.9385 10.5777 20 11.5278V6C20 4.89543 19.1046 4 18 4H6ZM20 12.9995C19.0878 11.7853 17.6356 11 16 11C13.2386 11 11 13.2386 11 16C11 17.6356 11.7853 19.0878 12.9995 20H18C19.1046 20 20 19.1046 20 18V12.9995Z"
            fill="url(#paint0_linear_123_14407)"
          />
          <rect x="7" y="7.5" width="10" height="1" rx="0.5" fill="#0E1465" />
          <rect x="7" y="10.5" width="3" height="1" rx="0.5" fill="#0E1465" />
          <rect x="7" y="14" width="2" height="1" rx="0.5" fill="#0E1465" />
          <circle cx="16" cy="16" r="5" fill="url(#paint1_linear_123_14407)" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 12C16.2761 12 16.5 12.2239 16.5 12.5V15.7929L17.8536 17.1464C18.0488 17.3417 18.0488 17.6583 17.8536 17.8536C17.6583 18.0488 17.3417 18.0488 17.1464 17.8536L15.705 16.4121C15.5737 16.2809 15.5 16.1028 15.5 15.9172V12.5C15.5 12.2239 15.7239 12 16 12Z"
            fill="#0E1465"
          />
          <defs>
            <linearGradient
              id="paint0_linear_123_14407"
              x1="12"
              y1="-2.5"
              x2="12"
              y2="20"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#5365F3" />
              <stop offset="1" stop-color="#4DFBFF" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_123_14407"
              x1="14.5"
              y1="24"
              x2="14.5"
              y2="11"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#5365F3" />
              <stop offset="1" stop-color="#4DFBFF" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default TimesheetModule;
